import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  Distributor,
  DynamicFormComponent,
  ModalComponent,
  QuestionBase,
  PopUpService,
  ProfileService
} from 'core/index';
import { BrokerCreditsDealerService } from '../broker-credits-dealer.service';

@Component({
  selector: 'lms-broker-credits-dealer',
  templateUrl: './broker-credits-dealer.component.html',
  styleUrls: ['./broker-credits-dealer.component.scss']
})
export class BrokerCreditsDealerComponent implements OnInit, OnChanges {
  @Input() distributor: Distributor;
  @Input() client: any;
  @Input() transactionType: string;
  @Output() transactionCompleted = new EventEmitter<Distributor>();
  @ViewChild(ModalComponent, { static: false }) public modal: ModalComponent;
  @ViewChild(DynamicFormComponent, { static: false }) public dynamicForm: DynamicFormComponent;
  public questions: QuestionBase<any>[] = [];
  public action: string;
  public decreaseAction: string;
  public canDecrease: boolean;
  public isDecrease: boolean;
  public manageButtonLabel: string;

  constructor(
    public dealerService: BrokerCreditsDealerService,
    public profileService: ProfileService,
    public translate: TranslateService,
    public popupService: PopUpService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    this.action = 'distributors.' + this.transactionType;
    this.decreaseAction =
      'distributors.' + (this.distributor.subscriptions.credits ? 'creditsDecrease' : 'subscriptionsDecrease');
    this.canDecrease =
      ['creditsPurchase', 'subscriptionsPurchase'].includes(this.transactionType) &&
      this.profileService.canExecute(this.decreaseAction) &&
      this.distributor.brokerBalance.amount > 0;
    this.manageButtonLabel = 'distributors.manage' + (this.distributor.subscriptions.credits ? 'Credits' : 'Seats');
  }

  openPurchaseModal() {
    this.isDecrease = false;
    this.questions = this.dealerService.getQuestions(
      this.transactionType,
      this.distributor,
      this.client,
      this.isDecrease
    );
    this.modal.open();
  }

  openDecreaseModal() {
    this.isDecrease = true;
    this.questions = this.dealerService.getQuestions(
      this.transactionType,
      this.distributor,
      this.client,
      this.isDecrease
    );
    this.modal.open();
  }

  createTransaction(data) {
    this.popupClose();
    if (this.isDecrease && data.amount > 0) {
      data.amount = -data.amount;
    }

    this.dealerService
      .createTransaction(this.transactionType, this.distributor, data)
      .then((transaction) => {
        this.endSubmit(null);
        this.transactionCompleted.emit(transaction);
      })
      .catch((err) => {
        this.endSubmit(null);
        this.popupService.showError({
          title: this.translate.instant(`distributors.${this.transactionType}Error`),
          text: err.serverMessage
        });
      });
  }

  popupClose() {
    this.modal.close();
  }

  endSubmit(value) {
    this.dynamicForm.submitted(value);
  }
}
